import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { MatFormField, MatLabel, MatInput, MatSuffix, MatHint } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'z-input-password',
    templateUrl: './z-input-password.component.html',
    styleUrls: ['./z-input-password.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatIconButton, MatSuffix, MatIcon, MatHint, TranslatePipe]
})
export class ZInputPasswordComponent {
    readonly label = input<string>('');
    readonly placeholder = input<string>('');
    readonly formControlRef = input<FormControl>(new FormControl());
    readonly required = input<boolean>(false);
    readonly id = input<string>('');
    readonly autocomplete = input<string>('new-password');
    readonly appearance =
        input<MatFormFieldAppearance>('outline');

    showPassword: boolean = false;
}
